import { FC, ReactNode, useMemo, useState } from 'react'

import { Progress, Spinner } from '@agro-club/agroclub-shared'

import { DocumentFile, DocumentType } from 'modules/domain/types'
import FileItem from 'views/components/FilesByTypes/FileItem'
import FilesGroup from 'views/components/FilesByTypes/FilesGroup'
import { FilesLayout, Loading } from 'views/components/FilesByTypes/styled'

export interface InternalFilesByTypesProps {
  types: DocumentType[]
  files: DocumentFile[]
  description?: Record<string, ReactNode>
  isAdd?: boolean
  loading?: boolean
  uploadProgress?: Progress
  deleteProgress?: Progress
  onUpload?: (document_type: string, files: File[]) => void
  onDelete?: (document_id: string) => void
}

const InternalFilesByTypes: FC<InternalFilesByTypesProps> = ({
  types = [],
  files = [],
  onUpload,
  onDelete,
  loading,
  isAdd,
  uploadProgress,
  deleteProgress,
  description,
}) => {
  const [uploadingDocType, setUploadingDocType] = useState<string | null>(null)
  const tree = useMemo(
    () =>
      types.map((type) => ({
        ...type,
        files: files.filter((file) => file.document_type === type.slug),
      })),
    [types, files],
  )

  const onUploadHandler = (document_type: string, files: File[]) => {
    if (files?.length && onUpload) {
      setUploadingDocType(document_type)
      onUpload(document_type, files)
    }
  }

  return (
    <FilesLayout>
      {loading && (
        <Loading>
          <Spinner />
        </Loading>
      )}

      {tree.map((item) => (
        <FilesGroup
          isAdd={isAdd}
          key={item.slug}
          header={item.label}
          onUpload={(files) => onUploadHandler(item.slug, files)}
          progress={uploadingDocType === item.slug ? uploadProgress : undefined}
          description={description?.[item.slug] ?? ''}
        >
          {item.files.length > 0 &&
            item.files.map((file) => (
              <FileItem key={file.id} file={file} onDelete={onDelete} progress={deleteProgress} />
            ))}
        </FilesGroup>
      ))}
    </FilesLayout>
  )
}

export default InternalFilesByTypes
